import { render } from "./ToolBarButton.vue?vue&type=template&id=ba2bc46e"
import script from "./ToolBarButton.vue?vue&type=script&lang=js"
export * from "./ToolBarButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__